import httpHelper from '../utils/httpHelper';
import urlConstants from '../shared/urlConstants';
import { v4 as uuidv4 } from 'uuid';

interface EmployeeObj {
    goalId?: string;
    organisationId: string;
    userName: string;
    employeeType: string;
    leadId: string;
    goalStartDate: number;
    goalEndDate: number;
    goals: string;
}

const fetchCurrentGoals = async (leadId: string, userName?: string) => {
    const postData = userName
        ? { userName }
        : { leadId };


    const params = [
        { param: '{actionName}', value: 'getGoalsData' },
    ];

    try {
        const response = await httpHelper.postData(
            httpHelper.getUri(urlConstants.ACTION, params),
            JSON.stringify(postData)
        );
        return response;
    } catch (error) {
        console.error('Error fetching goals:', error);
        throw error;
    }
};

// const fetchCurrentGoals = async (leadId: string, todaysDate: number, userName?: string) => {
//     const postData = userName
//         ? { userName, todaysDate }
//         : { leadId, todaysDate };

//     const params = [
//         { param: '{actionName}', value: 'getGoalsData' },
//     ];

//     try {
//         const response = await httpHelper.postData(
//             httpHelper.getUri(urlConstants.ACTION, params),
//             JSON.stringify(postData)
//         );
//         return response;
//     } catch (error) {
//         console.error('Error fetching goals:', error);
//         throw error;
//     }
// };

const createGoal = async (employeeData: any) => {
    const params = [{ param: '{object}', value: 'goals' }];
    const bodyObj = {
        'goalId': uuidv4(),
        'organisationId': employeeData.organisationId,
        'userName': employeeData.userName,
        'employeeType': employeeData.employeeType,
        'leadId': employeeData.leadId || employeeData.userName,
        'goalStartDate': employeeData.goalStartDate,
        'goalEndDate': employeeData.goalEndDate,
        'goals': employeeData.goals
    };

    return httpHelper.postData(
        httpHelper.getUri(urlConstants.CREATE_ITEM, params),
        JSON.stringify(bodyObj)
    );
};

const updateGoal = async (employeeData: EmployeeObj) => {
    const params = [{ param: '{object}', value: 'goals' }];
    const bodyObj = {
        'goalId': employeeData.goalId,
        'organisationId': employeeData.organisationId,
        'userName': employeeData.userName,
        'employeeType': employeeData.employeeType,
        'leadId': employeeData.leadId,
        'goalStartDate': employeeData.goalStartDate,
        'goalEndDate': employeeData.goalEndDate,
        'goals': employeeData.goals
    };

    return httpHelper.postData(
        httpHelper.getUri(urlConstants.UPDATE_ITEM, params),
        JSON.stringify(bodyObj)
    );
};

export { createGoal, updateGoal, fetchCurrentGoals };